import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "../api";

const ACTION_LABELS = {
  login_success: "Login", login_failed: "Login mislykkedes", logout: "Log ud",
  view_message: "Åbnede henvendelse", update_message: "Opdaterede henvendelse",
  export_csv_anonymized: "Eksporterede (anonymiseret)", create_user: "Oprettede bruger",
  set_user_active: "Ændrede brugerstatus", password_changed: "Skiftede adgangskode",
  access_denied: "Adgang nægtet", bootstrap_admin_created: "Oprettede første admin",
};
const fmtDate = (s) => (s ? new Date(s).toLocaleString("da-DK", { dateStyle: "medium", timeStyle: "short" }) : "");

const AuditLog = () => {
  const [res, setRes] = useState(null);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);

  useEffect(() => {
    setRes(null);
    api.auditLog({ page, page_size: 50 }).then(setRes).catch(() => setError("Kunne ikke hente log."));
  }, [page]);

  const totalPages = res ? Math.max(1, Math.ceil(res.total / res.page_size)) : 1;

  return (
    <div data-testid="admin-audit-page">
      <h1 className="font-display text-3xl text-[#1A2E24] mb-1">Aktivitetslog</h1>
      <p className="text-sm text-[#5C7567] mb-6">Sikkerhedslog uden personoplysninger. Kun administratorer har adgang.</p>

      {error && <p className="text-red-600" data-testid="admin-audit-error">{error}</p>}
      {!res && !error && <div className="flex items-center gap-2 text-[#5C7567]"><Loader2 className="h-5 w-5 animate-spin" /> Henter…</div>}

      {res && (
        <>
          <div className="rounded-2xl bg-white border border-black/5 overflow-hidden">
            <table className="w-full text-sm" data-testid="admin-audit-table">
              <thead>
                <tr className="text-left text-[#5C7567] border-b border-black/5">
                  <th className="px-4 py-3 font-medium">Tidspunkt</th>
                  <th className="px-4 py-3 font-medium">Bruger</th>
                  <th className="px-4 py-3 font-medium">Handling</th>
                  <th className="px-4 py-3 font-medium">Reference</th>
                </tr>
              </thead>
              <tbody>
                {res.items.map((a) => (
                  <tr key={a.id} className="border-b border-black/5 last:border-0">
                    <td className="px-4 py-3 text-[#1A2E24] whitespace-nowrap">{fmtDate(a.timestamp)}</td>
                    <td className="px-4 py-3 text-[#5C7567]">{a.user_email || "—"}</td>
                    <td className="px-4 py-3">{ACTION_LABELS[a.action] || a.action}</td>
                    <td className="px-4 py-3 text-[#5C7567] text-xs">{a.target_id || a.details || "—"}</td>
                  </tr>
                ))}
                {res.items.length === 0 && <tr><td colSpan={4} className="px-4 py-10 text-center text-[#5C7567]">Ingen hændelser.</td></tr>}
              </tbody>
            </table>
          </div>
          <div className="flex items-center justify-end gap-2 mt-4 text-sm text-[#5C7567]">
            <button disabled={page <= 1} onClick={() => setPage((p) => p - 1)}
              className="rounded-lg border border-black/10 px-3 py-1.5 disabled:opacity-40 hover:bg-white">Forrige</button>
            <span>Side {page} / {totalPages}</span>
            <button disabled={page >= totalPages} onClick={() => setPage((p) => p + 1)}
              className="rounded-lg border border-black/10 px-3 py-1.5 disabled:opacity-40 hover:bg-white">Næste</button>
          </div>
        </>
      )}
    </div>
  );
};

export default AuditLog;
